// Base breadcrumb styles (rendered inline — no inner breadcrumbs-type-1 component delegation)
// Dark-background variant: always uses dark navy background to match hero headers.
sn-breadcrumbs-type-2 {
  .breadcrumbs-type-2 {
    background-color: transparent;

    &__list {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: calc(var(--spacing-2xs) / 1.25);
    }

    &__item {
      display: flex;
      align-items: center;
      gap: calc(var(--spacing-2xs) * 1.2);

      &:last-child {
        .breadcrumbs-type-2__separator {
          display: none;
        }
      }
    }

    &__link,
    &__text {
      @include text-style('sm', 'md');

      text-decoration: none;
      transition: color 0.2s ease;
    }

    &__link {
      color: var(--color-neutral-white);

      &:hover {
        color: var(--color-brand-primary-light);
      }
    }

    &__text {
      color: var(--color-neutral-neutral-lighter);
      font-weight: map-get($font-weights, 'normal');
    }

    &__item--current &__text {
      color: var(--color-neutral-neutral-lighter);
      font-weight: map-get($font-weights, 'normal');
      text-decoration: none;
    }

    &__separator {
      display: flex;
      align-items: center;
      margin-top: 3px;

      .me-icon {
        @include size(16px);

        svg {
          fill: var(--color-neutral-white);
        }
      }
    }
  }

  .me-section {
    background-color: rgb(23 30 51 / 70%);
  }

  &.breadcrumbs-type-2--transparent {
    .me-section {
      background-color: transparent;
    }
  }

  // Deep space-blue variant (#000031) — pairs with sn-hero-header-type-7
  &.breadcrumbs-type-2--darkest {
    .me-section {
      background-color: var(--color-surface-darkest);
    }
  }
}
